import type { RawVideoReference, VideoReference } from '@/api/types';

/**
 * Приводит видео из API к форме приложения: `saved_board_ids` → `saved_canvas_ids`
 * (канвасы v2 живут поверх досок до B1), недостающие связи — пустые.
 * Длительность: ручная из админки, иначе измеренная у собственного файла (`media`) —
 * конвейер загрузки поле видео не заполняет, а файл знает её всегда.
 * Mock уже отдаёт целевую форму, для него функция прозрачна.
 */
export function normalizeVideo(raw: RawVideoReference): VideoReference {
  const savedIds = raw.saved_canvas_ids ?? raw.saved_board_ids ?? [];
  return {
    ...raw,
    saved_canvas_ids: savedIds,
    is_saved: raw.is_saved ?? savedIds.length > 0,
    categories: raw.categories ?? [],
    transition_types: raw.transition_types ?? [],
    tutorials: raw.tutorials ?? [],
    hook: raw.hook ?? null,
    extra: raw.extra ?? null,
    media: raw.media ?? null,
    preview_embed: raw.preview_embed ?? null,
    public_summary: raw.public_summary ?? null,
    public_summary_html: raw.public_summary_html ?? null,
    details_public: raw.details_public ?? null,
    duration_sec: raw.duration_sec ?? raw.media?.duration_sec ?? null,
    platform_video_id: raw.platform_video_id ?? null,
  };
}
